import httpClient from "@/httpClient"

const getPattern = (company = '{currentCompanySlug}') => httpClient.get(`${company || '{currentCompanySlug}'}/activity-stream/handlers-config`)
const appConfig = (company) => httpClient.get(`${company}/suppliers/${company}/application-configuration`)

export default {
  getPattern,
  appConfig,
}
